'use client';

import ServiceContent from '@/components/services/ServiceContent';
import GlobalShippingContent from '@/content/services/en/global-shipping.mdx';

export default function GlobalShippingClient() {
    return (
        <ServiceContent>
            <GlobalShippingContent />
        </ServiceContent>
    );
}

